
import axios from 'axios'
import { url } from './url'



function newCertTrigger(id){
    return axios.put(`${url}/trigger/${id}/newcert`)
        .then(resp => {
            return resp.data
        })
}

function getTriggers(query) {
    var urlString = `${url}/trigger`;
    return axios
        .get(urlString,{
            params:query
        })
        .then(res => {return {
            total: res.data.total,
            triggers: res.data.triggers.map(trigger => {
                return {
                    _id: trigger._id,
                    macAddress: trigger.macAddress,
                    customer: trigger.customer,
                    partner: trigger.partner,
                    createdAt: trigger.createdAt,
                    registeredAt: trigger.registeredAt,
                    certificateId: trigger.certificateId,
                    version: trigger.version,
                    versionRequestedAt: trigger.versionRequestedAt,
                };
            })
        }});
}

function createTrigger(trigger) {
    return axios.post(`${url}/trigger`, trigger)
        .then(resp => {
            return resp.data
        })
}
function deleteTrigger(id) {
    return axios.delete(`${url}/trigger/${id}`)
        .then(resp => {
            return resp.data
        })
}
function updateTrigger(trigger) {
    return axios.put(`${url}/trigger/${trigger._id}`, trigger)
        .then(resp => {
            return resp.data
        })
}
export default {
    getTriggers,
    createTrigger,
    deleteTrigger,
    updateTrigger,
    newCertTrigger
};